// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface OrgAppliedFilter
 */
export interface OrgAppliedFilter {
    /**
     * 
     * @type {string}
     * @memberof OrgAppliedFilter
     */
    filterOn: OrgAppliedFilterFilterOnEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgAppliedFilter
     */
    filterValues: Array<string>;
}

export function OrgAppliedFilterFromJSON(json: any): OrgAppliedFilter {
    return {
        'filterOn': json['filter_on'],
        'filterValues': json['filter_values'],
    };
}

export function OrgAppliedFilterToJSON(value?: OrgAppliedFilter): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'filter_on': value.filterOn,
        'filter_values': value.filterValues,
    };
}

/**
* @export
* @enum {string}
*/
export enum OrgAppliedFilterFilterOnEnum {
    OrganizationType = 'OrganizationType',
    Country = 'Country',
    Language = 'Language'
}


